const Backbone = require('backbone');
const Marionette = require('backbone.marionette');

const window = global.window;
const _ = require('underscore');
const ajaxListener = require('./ajax.js');
const $ = window.jQuery;
require('jquery.idle');
const parameters = require('./data/parameters.js');

const idleTime = parameters.get('idle_time') * 60000;

// @link https://github.com/marionettejs/marionette.inspector
if (window.__agent) {
  window.__agent.start(Backbone, Marionette);
}

const AppRootView = Marionette.LayoutView.extend({
  template() {
    return '<div class="app_content"></div>';
  },
  regions: {
    content: '.app_content'
  }
});

const AppRouter = Backbone.Router.extend({
  defaultParams: {},
  generate(route, params) {
    let url = route;

    _.each(_.extend(this.defaultParams, params), (value, param) => {
      url = url.replace(`:${param}`, value);
    });

    return url;
  }
});

module.exports = new Marionette.Application({
  router: new AppRouter(),
  rootView: new AppRootView(),
  onStart() {
    ajaxListener(this.rootView.$el);

    this.rootView.render();

    if (Backbone.history) {
      Backbone.history.start();
    }

    const delayToMidnight = this.getDelayToMidnight();

    // reload app at midnight
    setTimeout(() => {
      window.location.reload();
    }, delayToMidnight);

    // when no action during parameter idleTime, return to default view
    $(window).idle({
      onIdle: function() {
        this.vent.trigger('returnToDefault');
      }.bind(this),
      idle: idleTime,
      startAtIdle: true,
      recurIdleCall: true
    });
  },
  getDelayToMidnight() {
    const date = new Date();
    const time = date.getTime();
    date.setHours(24, 0, 0, 0);
    const delayToMidnight = Math.ceil(date - time);

    return delayToMidnight;
  }
});



// WEBPACK FOOTER //
// ./src/app.js